export const DEFAULT_CHART_VIEW = 'bar'

export const CHART_VIEW_MAPPING = [
  { text: 'Bar Chart', value: 'bar', listText: 'Bar Chart' },
  { text: 'Stacked Chart', value: 'stacked', listText: 'Stacked Chart' },
  { text: 'Scatter Plot', value: 'scatter', listText: 'Scatter Plot' }
]
